import { cookieRef } from '@layouts/stores/config'
import { Cookie } from '@/@vxapp/@Enums/Cookie'
import { useCookie } from '@/@core/composable/useCookie'

export const resolveVuetifyTheme = defaultTheme => {
  const cookieColorScheme = cookieRef(
    Cookie.ColorScheme,
    usePreferredDark().value ? 'dark' : 'light',
    false
  )

  const storedTheme = useCookie(Cookie.Theme).value ?? defaultTheme

  return storedTheme === 'system'
    ? cookieColorScheme.value === 'dark'
      ? 'dark'
      : 'light'
    : storedTheme
}
